import { toast } from "react-toastify";

interface NotificationOptions {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

// פונקציה פשוטה להצגת התראות במקום toast
export const showNotification = ({ type, message }: NotificationOptions) => {
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "warning":
      toast.warning(message);
      break;
    case "info":
      toast.info(message);
      break;
  }
};

export const showSuccess = (message: string) => showNotification({ type: 'success', message });
export const showError = (message: string) => showNotification({ type: 'error', message });
export const showWarning = (message: string) => showNotification({ type: 'warning', message });
export const showInfo = (message: string) => showNotification({ type: 'info', message });

// פונקציה לאישור פעולות מסוכנות
export const showConfirm = (message: string): boolean => {
  return window.confirm(message);
};
